(function () {
  var SECTION_TYPE = 'pdp-search-discovery-recommendations';
  var initializedRoots = new WeakSet();

  function getRoutes() {
    return (window.theme && window.theme.routes) || {};
  }

  function getCartUrl() {
    var routes = getRoutes();
    return routes.cart || '/cart';
  }

  function formatMoney(cents) {
    if (window.SmileCart && typeof window.SmileCart.formatMoney === 'function') {
      return window.SmileCart.formatMoney(cents);
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var format =
        (window.theme && window.theme.moneyFormat) ||
        (window.Shopify.currency && window.Shopify.currency.active);
      return Shopify.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  function buildRecommendationsUrl(sectionId, productId, intent, limit) {
    var routes = getRoutes();
    var prefix = routes.root_url || '/';
    var path = routes.product_recommendations_url || '/recommendations/products';
    if (prefix.slice(-1) !== '/') prefix += '/';
    if (path.charAt(0) === '/') path = path.slice(1);
    return (
      prefix +
      path +
      '?section_id=' +
      encodeURIComponent(sectionId) +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      encodeURIComponent(limit) +
      '&intent=' +
      encodeURIComponent(intent)
    );
  }

  function applyRecommendationVariant(card, option) {
    if (!card || !option) return;

    var btn = card.querySelector('[data-smile-rec-add]');
    var priceEl = card.querySelector('[data-smile-rec-price]');
    var compareEl = card.querySelector('[data-smile-rec-compare]');
    var oosEl = card.querySelector('[data-smile-rec-oos]');
    var errorEl = card.querySelector('[data-smile-rec-error]');
    var img = card.querySelector('[data-smile-rec-image]');

    var price = Number(option.dataset.price || 0);
    var compare = Number(option.dataset.compare || 0);
    var available = option.dataset.available === 'true';

    if (btn) {
      btn.dataset.variantId = option.value;
      btn.disabled = !available;
    }

    if (priceEl) priceEl.textContent = formatMoney(price);

    if (compareEl) {
      if (compare > price) {
        compareEl.textContent = formatMoney(compare);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (oosEl) oosEl.hidden = available;

    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    if (img && option.dataset.image) {
      img.src = option.dataset.image;
    }
  }

  function publishCartChange(cart) {
    if (window.SmileCart && typeof window.SmileCart.openDrawer === 'function') {
      window.SmileCart.openDrawer();
    }
    document.dispatchEvent(
      new CustomEvent('theme:cart:change', {
        detail: { cart: cart },
        bubbles: true,
      })
    );
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
  }

  function addRecommendationVariantToCart(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId) return Promise.resolve();

    var card = btn.closest('[data-pdp-rec-card], [data-smile-rec-card]');
    var errorEl = card && card.querySelector('[data-smile-rec-error]');
    var cartUrl = getCartUrl();

    btn.disabled = true;
    btn.classList.add('loading');

    return fetch(cartUrl + '/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(function () {
        return fetch(cartUrl + '.js', { credentials: 'same-origin' }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        publishCartChange(cart);
      })
      .catch(function (err) {
        if (errorEl) {
          errorEl.textContent =
            (err && err.description) || (err && err.message) || 'Could not add to cart';
          errorEl.hidden = false;
        }
      })
      .finally(function () {
        btn.classList.remove('loading');
        if (card) {
          var select = card.querySelector('[data-smile-rec-variant-select]');
          if (select) {
            applyRecommendationVariant(card, select.options[select.selectedIndex]);
          } else {
            btn.disabled = false;
          }
        }
      });
  }

  function bindRecommendationCard(card) {
    if (!card || card.dataset.pdpRecBound === 'true') return;
    card.dataset.pdpRecBound = 'true';

    if (card.dataset.mixMatchSave === 'true') {
      if (window.SmileCartMixMatch) {
        window.SmileCartMixMatch.bindCard(card, function () {
          return fetch(getCartUrl() + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(publishCartChange);
        });
      }
      return;
    }

    var select = card.querySelector('[data-smile-rec-variant-select]');
    var btn = card.querySelector('[data-smile-rec-add]');

    if (select) {
      select.addEventListener('change', function () {
        applyRecommendationVariant(card, select.options[select.selectedIndex]);
      });
      applyRecommendationVariant(card, select.options[select.selectedIndex]);
    }

    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.disabled || btn.classList.contains('loading')) return;
      addRecommendationVariantToCart(btn);
    });
  }

  function initRecommendationCards(scope) {
    if (!scope) return;
    scope.querySelectorAll('[data-pdp-rec-card], [data-smile-rec-card]').forEach(bindRecommendationCard);
  }

  function isMobileCarousel() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function shouldShowDots(root, carousel) {
    if (carousel && carousel.getAttribute('data-show-dots') === 'true') return true;
    return root && root.getAttribute('data-show-dots') === 'true';
  }

  function ensureCarouselHost(carousel) {
    var host = carousel.parentElement;
    if (!host || !host.classList.contains('pdp-sd-rec__carousel-host')) {
      var wrapper = document.createElement('div');
      wrapper.className = 'pdp-sd-rec__carousel-host';
      carousel.parentNode.insertBefore(wrapper, carousel);
      wrapper.appendChild(carousel);
      host = wrapper;
    }
    return host;
  }

  function getSlideScrollPosition(carousel, slide) {
    return carousel.scrollLeft + (slide.getBoundingClientRect().left - carousel.getBoundingClientRect().left);
  }

  function getActiveSlideIndex(carousel, slides) {
    var scrollLeft = carousel.scrollLeft;
    var active = 0;
    var minDistance = Infinity;

    for (var i = 0; i < slides.length; i++) {
      var target = getSlideScrollPosition(carousel, slides[i]);
      var distance = Math.abs(target - scrollLeft);
      if (distance < minDistance) {
        minDistance = distance;
        active = i;
      }
    }

    return active;
  }

  /**
   * Dot count adapts to how many products are shown.
   * Mobile: one dot per product. Desktop: one dot per page.
   */
  function getDotsConfig(carousel, slides) {
    var slideCount = slides.length;
    if (slideCount < 2) return null;

    if (isMobileCarousel()) {
      return { mode: 'product', count: slideCount };
    }

    var perRow = parseInt(carousel.getAttribute('data-grid-large') || '4', 10);
    perRow = Math.max(2, Math.min(4, perRow));

    if (slideCount <= perRow) return null;

    return {
      mode: 'page',
      count: Math.ceil(slideCount / perRow),
      perRow: perRow,
    };
  }

  function slideIndexToDotIndex(slideIndex, config) {
    if (config.mode === 'product') return slideIndex;
    return Math.floor(slideIndex / config.perRow);
  }

  function getActiveDotIndex(carousel, slides, config) {
    return slideIndexToDotIndex(getActiveSlideIndex(carousel, slides), config);
  }

  function scrollToDot(carousel, slides, config, dotIndex) {
    var slideIndex = config.mode === 'product' ? dotIndex : dotIndex * config.perRow;
    if (slideIndex >= slides.length) slideIndex = slides.length - 1;
    var slide = slides[slideIndex];
    if (!slide) return;
    carousel.scrollTo({
      left: getSlideScrollPosition(carousel, slide),
      behavior: 'smooth',
    });
  }

  function teardownDotListeners(carousel) {
    if (carousel._pdpSdScrollHandler) {
      carousel.removeEventListener('scroll', carousel._pdpSdScrollHandler);
      carousel._pdpSdScrollHandler = null;
    }
    if (carousel._pdpSdDotsObserver) {
      carousel._pdpSdDotsObserver.disconnect();
      carousel._pdpSdDotsObserver = null;
    }
  }

  function removePaginationDots(host) {
    var parent = host.parentElement;
    if (!parent) return;
    var dots = parent.querySelector('.pdp-sd-rec__dots');
    if (dots) dots.remove();
  }

  function syncDotsFromVisibility(carousel, slides, config, setActiveDot) {
    var rootRect = carousel.getBoundingClientRect();
    var bestIndex = 0;
    var bestRatio = 0;

    for (var i = 0; i < slides.length; i++) {
      var rect = slides[i].getBoundingClientRect();
      var visible =
        Math.min(rect.right, rootRect.right) - Math.max(rect.left, rootRect.left);
      if (rect.width <= 0) continue;
      var ratio = Math.max(0, visible) / rect.width;
      if (ratio > bestRatio) {
        bestRatio = ratio;
        bestIndex = i;
      }
    }

    setActiveDot(slideIndexToDotIndex(bestIndex, config));
  }

  function initPaginationDots(root, host, carousel) {
    teardownDotListeners(carousel);

    if (!shouldShowDots(root, carousel)) {
      removePaginationDots(host);
      return;
    }

    var slides = carousel.querySelectorAll('.pdp-sd-rec__slide');
    var config = getDotsConfig(carousel, slides);

    if (!config) {
      removePaginationDots(host);
      teardownDotListeners(carousel);
      return;
    }

    carousel._pdpSdDotsConfig = config;

    var dotsWrap = host.nextElementSibling;
    if (!dotsWrap || !dotsWrap.classList.contains('pdp-sd-rec__dots')) {
      dotsWrap = document.createElement('div');
      dotsWrap.className = 'pdp-sd-rec__dots';
      dotsWrap.setAttribute('role', 'tablist');
      dotsWrap.setAttribute('aria-label', 'Product recommendations');
      host.insertAdjacentElement('afterend', dotsWrap);
    }

    dotsWrap.innerHTML = '';
    dotsWrap.dataset.dotsMode = config.mode;

    var dotButtons = [];

    for (var i = 0; i < config.count; i++) {
      (function (dotIndex) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pdp-sd-rec__dot' + (dotIndex === 0 ? ' is-active' : '');
        dot.setAttribute('role', 'tab');

        if (config.mode === 'product') {
          dot.setAttribute('aria-label', 'Go to product ' + (dotIndex + 1));
        } else {
          dot.setAttribute(
            'aria-label',
            'Go to page ' + (dotIndex + 1) + ' of ' + config.count
          );
        }

        dot.setAttribute('aria-selected', dotIndex === 0 ? 'true' : 'false');

        dot.addEventListener('click', function () {
          scrollToDot(carousel, slides, config, dotIndex);
        });

        dotsWrap.appendChild(dot);
        dotButtons.push(dot);
      })(i);
    }

    function setActiveDot(index) {
      var safeIndex = Math.max(0, Math.min(index, dotButtons.length - 1));
      dotButtons.forEach(function (btn, i) {
        var isActive = i === safeIndex;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function syncActiveDot() {
      syncDotsFromVisibility(carousel, slides, config, setActiveDot);
    }

    slides.forEach(function (slide, index) {
      slide.dataset.pdpSdSlideIndex = String(index);
    });

    var observer = new IntersectionObserver(
      function () {
        syncActiveDot();
      },
      {
        root: carousel,
        threshold: [0, 0.2, 0.4, 0.6, 0.8, 1],
      }
    );

    slides.forEach(function (slide) {
      observer.observe(slide);
    });
    carousel._pdpSdDotsObserver = observer;

    var onScroll = function () {
      if (carousel._pdpSdScrollRaf) cancelAnimationFrame(carousel._pdpSdScrollRaf);
      carousel._pdpSdScrollRaf = requestAnimationFrame(syncActiveDot);
    };

    carousel._pdpSdScrollHandler = onScroll;
    carousel.addEventListener('scroll', onScroll, { passive: true });
    syncActiveDot();
  }

  function schedulePaginationDots(root, host, carousel) {
    function run() {
      initPaginationDots(root, host, carousel);
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(run);
    });

    window.setTimeout(run, 120);
    window.setTimeout(run, 400);

    carousel.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', run, { once: true });
        img.addEventListener('error', run, { once: true });
      }
    });
  }

  function initCarousel(root, output) {
    var carousel = output.querySelector('[data-pdp-sd-carousel]');
    if (!carousel || carousel.dataset.pdpSdCarouselReady === 'true') return;

    carousel.dataset.pdpSdCarouselReady = 'true';

    if (carousel.classList.contains('flickity-enabled')) return;

    var mobile = isMobileCarousel();
    var hasSlider = carousel.hasAttribute('data-slider');
    var host = ensureCarouselHost(carousel);
    var slides = carousel.querySelectorAll('.pdp-sd-rec__slide');
    var needsScroll = mobile || hasSlider;

    if (!needsScroll) {
      schedulePaginationDots(root, host, carousel);
      return;
    }

    if (mobile) {
      carousel.classList.add('pdp-sd-rec__carousel--scroll');
      carousel.style.setProperty('--pdp-sd-per-row', '1.7');
      carousel.style.setProperty('--pdp-sd-gap', '0.75rem');
    }

    if (mobile || hasSlider) {
      carousel.classList.add('pdp-sd-rec__carousel--scroll');
      schedulePaginationDots(root, host, carousel);
    }

    if (mobile) return;

    if (!hasSlider) return;

    var perRow = parseInt(carousel.getAttribute('data-grid-large') || '4', 10);
    if (perRow < 2) perRow = 2;
    if (perRow > 4) perRow = 4;

    carousel.classList.add('pdp-sd-rec__carousel--scroll');
    carousel.style.setProperty('--pdp-sd-per-row', String(perRow));

    schedulePaginationDots(root, host, carousel);

    if (slides.length <= perRow) return;

    var prev = host.querySelector('.pdp-sd-rec__nav--prev');
    var next = host.querySelector('.pdp-sd-rec__nav--next');

    if (!prev) {
      prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'pdp-sd-rec__nav pdp-sd-rec__nav--prev';
      prev.setAttribute('aria-label', 'Previous products');
      prev.innerHTML = '&#10094;';
      host.appendChild(prev);
    }

    if (!next) {
      next = document.createElement('button');
      next.type = 'button';
      next.className = 'pdp-sd-rec__nav pdp-sd-rec__nav--next';
      next.setAttribute('aria-label', 'Next products');
      next.innerHTML = '&#10095;';
      host.appendChild(next);
    }

    function scrollByPage(direction) {
      var slide = carousel.querySelector('.pdp-sd-rec__slide');
      if (!slide) return;
      var gap = parseFloat(getComputedStyle(carousel).gap) || 16;
      var offset = slide.offsetWidth + gap;
      var step = isMobileCarousel() ? 1 : perRow;
      carousel.scrollBy({ left: direction * offset * step, behavior: 'smooth' });
    }

    prev.onclick = function () {
      scrollByPage(-1);
    };
    next.onclick = function () {
      scrollByPage(1);
    };
  }

  function extractCarouselHtml(html) {
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var content = wrap.querySelector('[data-pdp-sd-recommendations-content]');
    if (!content) return '';
    return content.innerHTML;
  }

  function hasRecommendationCards(output) {
    return !!output.querySelector('[data-pdp-rec-card], [data-smile-rec-card]');
  }

  function setPanelVisible(root, visible) {
    var panel = root.querySelector('[data-pdp-sd-panel]');
    if (!panel) return;
    if (visible) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  function loadRecommendations(root) {
    if (!root || initializedRoots.has(root)) return;
    if (!root.getAttribute('data-product-id')) return;

    var output = root.querySelector('[data-pdp-sd-output]');
    if (!output) return;

    if (hasRecommendationCards(output)) {
      initializedRoots.add(root);
      initRecommendationCards(root);
      var existingCarousel = output.querySelector('[data-pdp-sd-carousel]');
      if (existingCarousel) existingCarousel.dataset.pdpSdCarouselReady = 'false';
      initCarousel(root, output);
      setPanelVisible(root, true);
      return;
    }

    var sectionId = root.getAttribute('data-section-id');
    var productId = root.getAttribute('data-product-id');
    var intent = root.getAttribute('data-intent') || 'complementary';
    var limit = root.getAttribute('data-limit') || '4';
    var fallback = root.getAttribute('data-fallback-related') === 'true';

    initializedRoots.add(root);

    function renderFromResponse(html) {
      var carouselHtml = extractCarouselHtml(html);
      if (carouselHtml) {
        output.innerHTML = carouselHtml;
        setPanelVisible(root, true);
        initRecommendationCards(root);
        var carousel = output.querySelector('[data-pdp-sd-carousel]');
        if (carousel) carousel.dataset.pdpSdCarouselReady = 'false';
        initCarousel(root, output);
        return true;
      }
      return false;
    }

    function fetchIntent(nextIntent) {
      return fetch(buildRecommendationsUrl(sectionId, productId, nextIntent, limit), {
        credentials: 'same-origin',
      }).then(function (r) {
        return r.text();
      });
    }

    fetchIntent(intent)
      .then(function (html) {
        if (renderFromResponse(html)) return;
        if (intent === 'complementary' && fallback) {
          return fetchIntent('related').then(function (relatedHtml) {
            if (!renderFromResponse(relatedHtml)) {
              output.innerHTML = '';
              setPanelVisible(root, false);
            }
          });
        }
        output.innerHTML = '';
        setPanelVisible(root, false);
      })
      .catch(function () {
        output.innerHTML = '';
        setPanelVisible(root, false);
      });
  }

  function initSection(root) {
    if (!root) return;
    loadRecommendations(root);
  }

  function initAll() {
    document.querySelectorAll('[data-pdp-sd-recommendations]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var container = evt.target;
    if (!container) return;
    var root =
      container.matches('[data-pdp-sd-recommendations]')
        ? container
        : container.querySelector('[data-pdp-sd-recommendations]');
    if (root) {
      initializedRoots.delete(root);
      initSection(root);
    }
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('[data-pdp-sd-recommendations]').forEach(function (root) {
        var output = root.querySelector('[data-pdp-sd-output]');
        var carousel = output && output.querySelector('[data-pdp-sd-carousel]');
        if (!carousel) return;
        carousel.dataset.pdpSdCarouselReady = 'false';
        var host = carousel.closest('.pdp-sd-rec__carousel-host') || carousel.parentElement;
        initCarousel(root, output);
        if (host) schedulePaginationDots(root, host, carousel);
      });
    }, 150);
  });
})();
